module.exports = __webpack_public_path__ + "img/stakebodyatten_parked.da9eb80b.svg";